module.exports = __webpack_public_path__ + "static/media/chevron-left.ef6cd9a4.svg";